import React, { useEffect } from 'react';
import pause from '../../assets/images/player/pause.svg'
import volume66 from '../../assets/images/player/volume66.svg'
import ytIconColor from '../../assets/images/youtube_social_icon_white.png'

function AddMashup(props) {
  
  function changeSong(title, type) {
    document.getElementById(`footer-copyright`).style.display = `none`
    document.getElementById(`audio-player-container`).style.display = `block`
    document.getElementById(`audio-player`).style.display = `grid`
    
    document.getElementById(`song-title`).innerHTML = title
    document.getElementById(`player-source`).src = `/assets/audio/` + type + `/` + title + `.mp3`
    
    document.getElementById(`song-cover`).src = `/assets/images/covers/${props.type}/${props.title}.png`
    
    document.getElementById('track-progress').style.width = `0px`
    document.getElementById('track-progress').style.width = `0px`
    
    document.getElementById(`song-volume`).style.maskImage = `url(${volume66})`
    document.getElementById(`song-volume`).style.WebkitMaskImage = `url(${volume66})`
    
    document.getElementById(`player-source`).volume = 0.30
    document.getElementById(`player-source`).play()
    
    document.getElementById(`song-play-pause`).style.maskImage = `url(${pause})`
    document.getElementById(`song-play-pause`).style.WebkitMaskImage = `url(${pause})`
  }
  
  function shareSong(title) {
    let shareSongTitle = `share-song-` + title.replace(/ /g,`_`)
    
    if (document.getElementById(shareSongTitle).nextSibling.style.visibility !== `visible`) {
      document.getElementById(shareSongTitle).nextSibling.style.visibility = `visible`
      document.addEventListener(`click`, addEventToDocument)
    } else {
      document.getElementById(shareSongTitle).nextSibling.removeAttribute(`style`)
    }
  }
  
  function addEventToDocument(event) {
    let shareSongTitle = `share-song-` + props.title.replace(/ /g,`_`),
        shareTitle = `share-` + props.title.replace(/ /g,`_`)
        
    if ((event.target.id !== shareTitle) && (event.target.id !== shareSongTitle)) {
      document.getElementById(shareSongTitle).nextSibling.removeAttribute(`style`)
      document.removeEventListener(`click`, addEventToDocument)
    }
  }
  
  useEffect(() => {
    if ((props.link === undefined)) {
      document.getElementById(`share-song-${props.title.replace(/ /g,"_")}`).style.display = `none`
    }
  })
  
  return (
    <div id="change-song-container">
      <button className="change-song" onClick={() => changeSong(`${props.title}`, `${props.type}`)}>
        <p className="title">{props.title}</p>
        <img className="cover" src={`/assets/images/covers/${props.type}/${props.title}.png`} alt={props.title} loading="lazy" />
        <span className="play"></span>
      </button>
      <button id={`share-song-${props.title.replace(/ /g,"_")}`} className="share-song" onClick={() => shareSong(`${props.title}`)}>&bull;&bull;&bull;</button>
      <div id={`share-${props.title.replace(/ /g,"_")}`} className="share">
        <a href={`https://www.youtube.com/watch?v=${props.link}`} target="_blank" rel="noreferrer">
          <img src={ytIconColor} alt="YouTube"/>
          <span>Watch on YouTube</span>
        </a>
      </div>
    </div>
  )
}

export default AddMashup